import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

type NavigationArrowsProps = {
  onPrevious: () => void
  onNext: () => void
  showLabels?: boolean
  currentIndex?: number
  total?: number
  className?: string
  size?: "sm" | "md" | "lg"
}

const sizeMap = {
  sm: "w-5 h-5",
  md: "w-6 h-6",
  lg: "w-7 h-7",
}

export default function NavigationArrows({
  onPrevious,
  onNext,
  showLabels = false,
  currentIndex,
  total,
  className,
  size = "md",
}: NavigationArrowsProps) {
  const iconSize = sizeMap[size]

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <button
        onClick={onPrevious}
        className={cn(
          "text-system-gray-400 hover:text-white",
          "transition-colors duration-200",
          "focus:outline-none",
        )}
        aria-label="Previous"
      >
        <ChevronLeftIcon className={iconSize} />
      </button>

      {showLabels && currentIndex !== undefined && total !== undefined && (
        <span className="text-sm text-system-gray-500">
          {currentIndex + 1} / {total}
        </span>
      )}

      <button
        onClick={onNext}
        className={cn(
          "text-system-gray-400 hover:text-white",
          "transition-colors duration-200",
          "focus:outline-none",
        )}
        aria-label="Next"
      >
        <ChevronRightIcon className={iconSize} />
      </button>
    </div>
  )
}
